import { render } from "./Sidebar.vue?vue&type=template&id=6607d201&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import "./Sidebar.vue?vue&type=style&index=0&id=6607d201&scoped=true&lang=css"

import exportComponent from "C:\\Users\\TAfolabi\\Documents\\Projects\\legacy\\partner\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6607d201"]])

export default __exports__